import classNames from "classnames";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { FieldError } from "@/components/ui/field";
import styles from "./week_days_select.module.css";

const DAYS = [
  { value: "mon", label: "Mo" },
  { value: "tue", label: "Tu" },
  { value: "wed", label: "We" },
  { value: "thu", label: "Th" },
  { value: "fri", label: "Fr" },
  { value: "sat", label: "Sa" },
  { value: "sun", label: "Su" },
]

export function WeekDaysSelect({ value, onChange, errors, disabled }) {
  return (
    <div className={classNames("flex flex-col gap-1", { "opacity-50 pointer-events-none": disabled })}>
      <ToggleGroup variant="outline" type="multiple" value={value} onValueChange={onChange} className={styles.panel}>
        {DAYS.map(({ value: day, label }) => (
          <ToggleGroupItem key={day} value={day} className={styles.button}>
            {label}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
      {errors?.map((error, i) => (
        <FieldError key={i}>{error}</FieldError>
      ))}
    </div>
  )
}
